import { merge } from 'lodash';

import { enTranslationsBoCommon } from '@sh4res/bo-common/i18n/en';
import { assetTypeTranslations } from '@sh4res/bo-common/i18n/fr/asset_types';
import { b2bTranslations } from '@sh4res/bo-common/i18n/fr/b2b';
import { instrumentsTranslations } from '@sh4res/bo-common/i18n/fr/instruments';
import { usersTranslations } from '@sh4res/bo-common/i18n/fr/users';

const translations = {
  bo_common: {
    actions: {
      next: 'Suivant',
      back: 'Précédent',
      continue_later: 'Continuer plus tard',
      save_draft: {
        success: 'Brouillon enregistré',
        failure: "Échec de l'enregistrement: %{error}",
        errors: {
          campaigns: {
            overlap_campaign_fiscal_period:
              'Une campagne du même type existe déjà pour cette entreprise et se trouve dans la même période fiscale.',
            overlap_campaign_consultation_period:
              'Une campagne du même type existe déjà pour cette entreprise et se trouve dans la même période de consultation.',
          },
        },
      },
      type_to_search: 'Commencez à taper pour rechercher',
      drop_file: 'Déposez votre fichier ici',
    },
    export: {
      failure: "L'export a échoué : %{error}",
      without_filter: {
        title: 'Exporter toute la liste ?',
        content:
          "Aucun filtre n'est appliqué : la liste complète sera exportée. Cet export peut être très volumineux, prendre du temps et solliciter fortement le système. Pensez à appliquer des filtres au préalable (par exemple la période de création). Voulez-vous tout de même exporter la liste complète ?",
      },
    },
    version: {
      new_available: 'Nouvelle version disponible',
      cta: 'Rafraîchir',
    },
    filters: {
      search_placeholder: 'Rechercher un filtre',
      no_match: 'Aucun filtre ne correspond à « %{query} »',
    },
    profile_popup: {
      role: 'Habilitation',
      language: 'Langue',
      settings: 'Paramètres',
      start_tour: 'Démarrer la visite',
    },
    ...instrumentsTranslations,
    users: usersTranslations,
    b2b: b2bTranslations,
    asset_types: assetTypeTranslations,
    all_documents: {
      list_modal: {
        title: 'Documents',
        download: 'Télécharger',
        no_preview: 'Le fichier ne peut pas être prévisualisé',
      },
      edit_modal: {
        title: 'Modifier le document',
      },
      no_permission: "Vous n'avez pas la permission de voir ce document",
      actions: { edit: { success: 'Modification réussie', failure: 'sauvegarde %{error}' } },
    },
    file_upload: {
      error: 'Erreur sur le fichier : %{error}',
      password_protected:
        'Le fichier donné est protégé par un mot de passe, veuillez donner un fichier valide.',
    },
    validation: {
      invalid_international_phone_number_format:
        "Le numéro doit commencer par + suivi de l'indicatif du pays (ex: +33...)",
      invalid_international_phone_number: 'Numéro de téléphone international invalide',
      invalid_mobile_phone_number: 'Doit être un numéro de téléphone mobile',
      invalid_date: 'Veuillez saisir une date valide comprise entre les années 1900 et 9999',
      url_invalid: 'Veuillez saisir une URL valide incluant le protocole (par exemple, https://)',
      iban: {
        checksum_not_number: "La clé de contrôle n'est pas un nombre",
        no_iban_country: "Code pays introuvable dans l'IBAN",
        no_iban_provided: "Ceci n'est pas un IBAN",
        qriban_not_allowed: "Le format QR-IBAN n'est pas autorisé",
        wrong_bban_format: 'Format du BBAN incorrect',
        wrong_bban_length: 'Longueur du BBAN incorrecte',
        wrong_iban_checksum: 'Clé de contrôle IBAN invalide',
        format: "Format d'IBAN invalide",
      },
      bic: {
        checksum_not_number: "Ceci n'est pas un code BIC valide",
        no_bic_country: 'Code pays introuvable dans le BIC',
        wrong_bic_format: 'Format du BIC incorrect',
      },
    },
    year: 'Année',
    services_page: {
      title: 'Services',
      savings_coach: {
        title: 'Coach Épargne',
        description:
          "Le service Coach Épargne est un service d'accompagnement personnalisé à destination des salariés, leur permettant de bénéficier d'un rendez-vous téléphonique avec un conseiller financier spécialisé, afin d'être guidés dans leurs décisions d'investissement au sein de leur plan d'épargne salariale ou retraite.",
      },
      robot_advisor: {
        title: 'Robot Advisor',
        description:
          "Le Robot Advisor est un module intégré à la plateforme permettant à un Salarié d'être guidé dans ses choix d'investissement ou de gestion de l'épargne. Il repose sur un questionnaire dynamique dont les réponses permettent de recommander une ou plusieurs allocations cibles en fonction du profil de l'utilisateur, de son horizon d'investissement, de ses objectifs et préférences en matière d'épargne.",
      },
    },
    accessibility: {
      back: 'Retour',
      clear: 'Effacer',
      close: 'Fermer',
      copy_id: "Copier l'ID",
      copied: 'Copié dans le presse-papiers',
      delete: 'Supprimer',
      toggle: 'Basculer',
      stepper: {
        ariaLabel: '%{label}, étape %{current} sur %{total}%{suffix}',
        currentSuffix: ', étape actuelle',
      },
      sorted_ascending: 'Trié par %{field} par ordre croissant',
      sorted_descending: 'Trié par %{field} par ordre décroissant',
    },
    meta: {
      page: '%{title} - Page %{page}',
    },
    yes: 'Oui',
    no: 'Non',
  },
} satisfies typeof enTranslationsBoCommon;

export const frTranslationsBoCommon = merge({}, enTranslationsBoCommon, translations);
